<div class="screen screen--region">

  <header class="screen__head screen__head--reserve region__head">
    <p class="belturo-eyebrow"><%= region %></p>
    <h1 class="screen__title"><%= _lcs( 'Entdecken' ) %></h1>
  </header>

  <!-- Category chips: Restaurants / Sehenswürdigkeiten / Touren -->
  <div class="chips region__chips">
    <% categories.forEach( function( c ) { %>
      <button class="chip<%= c.id === active ? ' chip--active' : '' %>" type="button" data-category="<%= c.id %>">
        <i class="icon icon--<%= c.icon %> chip__icon"></i><%= _lcs( c.label ) %>
      </button>
    <% } ); %>
  </div>

  <!-- Count + list/map switch -->
  <div class="region__bar">
    <span class="region__count" data-id="count"></span>
    <div class="viewswitch">
      <button class="viewswitch__btn viewswitch__btn--on" type="button" data-view="list">
        <i class="icon icon--list"></i><%= _lcs( 'Liste' ) %>
      </button>
      <button class="viewswitch__btn" type="button" data-view="map">
        <i class="icon icon--map"></i><%= _lcs( 'Karte' ) %>
      </button>
    </div>
  </div>

  <!-- List view -->
  <div class="region__list" data-id="list">

    <p class="region__state" data-id="state" hidden></p>

    <% cards.forEach( function( p ) { %>
      <button class="regioncard" type="button" data-entry="<%= p.kind %>:<%= p.id %>">
        <span class="regioncard__media ga-photo ga-photo--<%= p.photo %>">
          <% if ( p.image ) { %>
            <img class="regioncard__photo" src="<%= p.image %>" alt="<%= p.imageAlt %>" loading="lazy" />
          <% } else { %>
            <i class="icon icon--<%= p.icon %>"></i>
          <% } %>
        </span>
        <span class="regioncard__body">
          <span class="badge badge--accent badge--sm"><%= p.cat %></span>
          <span class="regioncard__title"><%= p.title %></span>
          <span class="regioncard__meta">
            <% if ( p.distance ) { %>
            <span class="regioncard__fact"><i class="icon icon--map-pin"></i><%= p.distance %></span>
            <% } %>
            <% if ( p.meta ) { %>
            <span class="regioncard__fact"><%= p.meta %></span>
            <% } %>
          </span>
          <% if ( p.open ) { %>
          <span class="regioncard__open"><%= p.open %></span>
          <% } %>
        </span>
      </button>
    <% } ); %>

  </div>

  <!-- Map view. The canvas is only measured once it is visible — see
       RegionState._showMap. -->
  <div class="region__map" data-id="map" hidden>
    <div class="region__map-canvas" data-id="map-canvas"></div>

    <p class="region__map-hint" data-id="map-hint" hidden></p>

    <div class="mapctl">
      <button class="mapctl__btn" type="button" data-map="in" aria-label="<%= _lcs( 'Vergrößern' ) %>"><i class="icon icon--plus"></i></button>
      <button class="mapctl__btn" type="button" data-map="out" aria-label="<%= _lcs( 'Verkleinern' ) %>"><i class="icon icon--minus"></i></button>
      <button class="mapctl__btn" type="button" data-map="reset" aria-label="<%= _lcs( 'Alles zeigen' ) %>"><i class="icon icon--locate-fixed"></i></button>
    </div>

    <!-- The tapped pin, as a card over the map. -->
    <button class="mapcard" type="button" data-id="map-card" hidden>
      <span class="mapcard__media ga-photo" data-id="map-card-media"></span>
      <span class="mapcard__body">
        <span class="mapcard__cat" data-id="map-card-cat"></span>
        <span class="mapcard__title" data-id="map-card-title"></span>
        <span class="mapcard__meta" data-id="map-card-meta"></span>
      </span>
      <i class="icon icon--chevron-right mapcard__chev"></i>
    </button>
  </div>

</div>
